import React from "react";

export interface FinanceResponsiveTableProps {
  children: React.ReactNode;
  className?: string;
  containerClassName?: string;
}

export function FinanceResponsiveTable({
  children,
  className = "",
  containerClassName = "",
}: FinanceResponsiveTableProps) {
  return (
    <div className={`relative w-full overflow-x-auto rounded-md border border-border/80 bg-card shadow-2xs ${containerClassName}`}>
      <div className={`min-w-full inline-block align-middle ${className}`}>
        {children}
      </div>
    </div>
  );
}
